class SalesRepresentativeRegistrationForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.form.addEventListener('submit', this.handleSubmit.bind(this))
    this.acceptTermsCheckbox = this.querySelector('input[id="AcceptTerms"]')
    this.userExistsError = this.querySelector('div#UserExistsError')
    this.generalError = this.querySelector('div#GeneralError')
    this.successMessage = this.querySelector('div#SuccessMessage')
    this.submitText = this.querySelector('button[type="submit"] div.text')
    this.submitSpinner = this.querySelector('button[type="submit"] div.loading-overlay')
  }

  connectedCallback() {
    this.acceptTermsCheckbox.addEventListener('change', this.handleAcceptTermsCheckboxChange.bind(this))
  }

  disconnectedCallback() {
    this.acceptTermsCheckbox.removeEventListener('change', this.handleAcceptTermsCheckboxChange.bind(this))
  }

  async handleSubmit(e) {
    try {
      e.preventDefault()
      this.submitText.classList.add('hidden')
      this.submitSpinner.classList.remove('hidden')
      const formData = new FormData(this.form)
      const data = Object.fromEntries(formData.entries())

      const formattedData = {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        type: 'Dealer',
      }
      const response = await fetch(
        `https://europe-west1-shopify-infrastructure.cloudfunctions.net/b2bRegistration_salvadora`,
        { ...fetchConfig(), ...{ body: JSON.stringify(formattedData) } },
      )
      const responseData = await response.json()
  
      if (responseData.success === false) {
        if (responseData.message === 'userExists') {
          this.userExistsError.classList.remove('hidden')
          this.generalError.classList.add('hidden')
        } else {
          this.generalError.classList.remove('hidden')
          this.userExistsError.classList.add('hidden')
        }
        this.successMessage.classList.add('hidden')
      } else {
        this.successMessage.classList.remove('hidden')
        this.userExistsError.classList.add('hidden')
        this.generalError.classList.add('hidden')
        this.form.reset()
        this.form.classList.add('hidden')
      }
    } catch(e) {
      console.error(e)
      this.successMessage.classList.add('hidden')
      this.userExistsError.classList.add('hidden')
      this.generalError.classList.remove('hidden')
    }
    this.submitText.classList.remove('hidden')
    this.submitSpinner.classList.add('hidden')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  handleAcceptTermsCheckboxChange() {
    if (this.acceptTermsCheckbox.checked) {
      this.querySelector('button[type="submit"]').removeAttribute('disabled')
    } else {
      this.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled')
    }
  }
}

customElements.define('sales-representative-registration-form', SalesRepresentativeRegistrationForm)
